import { ReactComponent } from "./ic_alert_cam.svg";

interface Props {
  fill?: string;
  className?: string;
  width?: string;
  height?: string;
}

const WithoutPhotoIcon: React.FC<Props> = (Props) => (
  <ReactComponent {...Props} />
);

export default WithoutPhotoIcon;
